<template>
    <article class="block--article  block--light block--listed">
        <a class="inner  block--long block--arrow-right block--padding-30" :href="postdata.slug">
            <span class="screen-reader-text">(Open post)</span>
            <div class="meta post-meta">
                <ul class="category--list">
                    <li class='cat' :key="catname" v-for="catname in postdata.cat_names">
                        {{catname}}
                        <span class='sep'>,</span>
                    </li>
                </ul>
                <time class="piblish" :datetime="postdata.post_date" >{{ postDate }}</time>
            </div>
            <h3 class="text--300 titler titler" v-html="postdata.title"></h3>
        </a>
    </article>
</template>


<script>
import moment from 'moment';

export default {
    name: 'postblock',
    props: ['postdata'],
    data(){
        return {
            post_cats : [],
            taxonomies: {},
        };
    },
    computed: {
        postDate(){
            let locale = 'en';
            let format = 'MMMM D, YYYY';
            if(theme_data.language === 'no' || theme_data.language === 'nb' ) {
                locale = 'nb';
                format = 'D. MMMM YYYY';
            }
            moment.locale( locale );
            return moment.unix(this.postdata.publish_date).format(format);
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/js/vue/components/postBlock.vue?7590c143